import axios from 'axios'
import {ArticuloSeccion} from "./model.js";


//#region Configuracion
function ObtenerSecciones(){

  return axios({
    method:"post",
    url: "/Shop/srvc.aspx/ObtenerSecciones",
    data: {}
  })
}

async function ObtenerCulture() {
  return axios({
    method:"post",
    url: "/Shop/srvc.aspx/ObtenerCulture",
    data: {}
  })
}

async function ObtenerArticulosPortada(){

  let respuesta = await axios({
    method:"post",
    url: "/Shop/srvc.aspx/ObtenerArticulosPortada",
    data: {}
  });
  return respuesta.data.d.map(reg => {
    let articulo = new ArticuloSeccion;
    Object.assign(articulo, reg);
    //Esto lo podría meter directamente en el get
    if (reg.Id_Imagen === "") 
      articulo.Imagen = "dist/img/sin-image-actividad.png";
    else
      articulo.Imagen ="/images.ashx?maxheight=200&maxwidth=200&id=" + reg.Id_Imagen;
    
    return articulo;
  });
}

async function ObtenerArticulosSeccion(idSeccion){

  let respuesta = await axios({
    method:"post",
    url: "/Shop/srvc.aspx/ObtenerArticulosSeccion",
    data: {
      "idSeccion": idSeccion
    }
  });
  return respuesta.data.d.map(reg => {
    let articulo = new ArticuloSeccion;
    Object.assign(articulo, reg);
    //Esto lo podría meter directamente en el get
    if (reg.Id_Imagen === "") 
      articulo.Imagen = "dist/img/sin-image-actividad.png";
    else
      articulo.Imagen ="/images.ashx?maxheight=200&maxwidth=200&id=" + reg.Id_Imagen;
    
    return articulo;
  });
}

async function ObtenerArticulosPromocion(){

  let respuesta = await axios({
    method:"post",
    url: "/Shop/srvc.aspx/ObtenerArticulosDestacados",
    data: {}
  });
  return respuesta.data.d.map(reg => {
    let articulo = new ArticuloSeccion;
    Object.assign(articulo, reg);
    //Esto lo podría meter directamente en el get
    if (reg.Id_Imagen === "") 
      articulo.Imagen = "dist/img/sin-image-actividad.png";
    else
      articulo.Imagen ="/images.ashx?maxheight=200&maxwidth=200&id=" + reg.Id_Imagen;
    
    return articulo;
  });
}

function ObtenerDetalleArcitulo(idArticulo){

  return axios({
    method:"post",
    url: "/Shop/srvc.aspx/ObtenerDetalleArcitulo",
    data: {
      "idArticulo": idArticulo
    }
  })
}
//#endregion

//#region Compra
async function Comprar(pedido) {  
  let respuesta = await axios({
    method:"post",
    url: "/Shop/srvc.aspx/HacerPedido",
    data: {pedido}
  })
  return respuesta;
}
//#endregion  

async function ObtenerInfoCliente() {
  let respuesta = await axios({
    method: "Post",
    url: "/Shop/srvc.aspx/ObtenerInfoCliente",
    data:{}
  })
  return respuesta;
}

export default {

  ObtenerSecciones,
  ObtenerArticulosSeccion,
  ObtenerDetalleArcitulo,
  Comprar,
  ObtenerInfoCliente,
  ObtenerArticulosPortada,
  ObtenerArticulosPromocion,
  ObtenerCulture  
  
}